<!--
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-08-09 17:27:52
 * @Version: 1.0
 * @Description:  邀请报价的对话框页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <el-dialog :append-to-body="true" :visible="true" title="邀请报价" width="80%" @close="invitationManager.close">
    <div v-loading="invitationManager.loading" class="invitation-data">
      <el-form ref="invitationForm" :model="invitationForm" class="invitation-form" :inline="true">
        <div class="condition-group">
          <el-form-item label="始发地" prop="startPlace">
            <el-cascader
              v-model="invitationForm.startPlace"
              style="width:200px"
              :options="area"
              :filterable="true"
              :props="{ expandTrigger: 'hover', checkStrictly: true }"
            />
          </el-form-item>
          <el-form-item label="目的地" prop="stopPlace">
            <el-cascader
              v-model="invitationForm.stopPlace"
              style="width:200px"
              :options="area"
              :filterable="true"
              :props="{ expandTrigger: 'hover', checkStrictly: true }"
            />
          </el-form-item>
        </div>
        <div class="manager-button">
          <el-form-item class="form-item form-item-sou">
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="invitationFormSummit"
            >
              <i class="el-icon-search" />查询
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              @click="resetInvitationForm"
            >
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
            <el-button
              size="small"
              style="background-color: #BE2316;border-color: #F56C6C;"
              class="form-item-btn"
              type="primary"
              :disabled="invitationManager.loading"
              @click="invitationEvent"
            >&nbsp;&nbsp;确定</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="invitation-data-header">
        <ul>
          <li>
            <el-checkbox v-model="allSelection" @change="invitationSelection()" />
          </li>
          <li>起运地/目的地</li>
          <li>货源信息</li>
          <li>发布时间</li>
          <!-- <li>报价价格</li> -->
          <li>邀请状态</li>
        </ul>
      </div>
      <div class="invitation-data-body">
        <template v-if="invitationData.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item, index) of invitationData">
          <div :key="index" class="data-item">
            <ul>
              <li>
                <el-checkbox
                  v-model="item.selection"
                  :disabled="Boolean(item.inviteType)"
                  @change="invitationChange()"
                />
              </li>
              <li>{{ item.startPlaceLabel }}一{{ item.stopPlaceLabel }}</li>
              <li>{{ item.goodsTypeLabel }}ᅳ{{ item.goodsName }}</li>
              <li>{{ item.createDate|_data }}</li>
              <!-- <li>{{ item.offerPrice || '未报价' }}</li> -->
              <li>{{ item.inviteType? '已邀请': '未邀请' }}</li>
            </ul>
          </div>
        </template>
      </div>
      <div class="invitation-data-pagination">
        <el-pagination
          :current-page="invitationPagination.pageNo"
          :total="invitationPagination.total"
          :page-size="invitationPagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="invitationChangeCurrent"
          @size-change="invitationChangeSize"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Page } from '@/utils/commonDataModel'
import { getInvitationGoodsList } from '@/api/personal/find/goodsManager'
import { saveList } from '@/api/personal/find/goodsInvitation'
import mixinsFunction from '@/utils/mixinsFunction'
export default {
  name: 'InvitationOffer',
  mixins: [mixinsFunction],
  props: {
    data: {
      type: [Object],
      default: () => {}
    },
    area: {
      type: [Array],
      default: () => []
    }
  },
  data: function() {
    return {
      invitationForm: {},
      invitationParam: {},
      allSelection: false,
      // 要显示的邀请货源
      invitationData: [],
      // 邀请列表表格分页
      invitationPagination: new Page(),
      invitationManager: {
        visible: false,
        close: () => {
          this.close()
        },
        loading: false
      }
    }
  },
  created: function() {
    console.log(this.props,'11111111111111111111')
    this.loadData()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.invitationFormSummit()
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    invitationEvent() {
      const ids = this.invitationData
        .filter(item => item.selection)
        // .map(item => item.id)
      if (ids.length < 1) {
        this.$message({
          type: 'warning',
          message: '请选择要邀请的数据!'
        })
        return false
      } else if (ids.length > 10) {
        this.$message({
          type: 'warning',
          message: '一次最多只能邀请10个!'
        })
        return false
      }
      this.invitationManager.loading = true
      const params = {
        goodsIds: ids.map(item => item.id).toString(),
        goodsNames: ids.map(item => item.goodsName).toString(),
        companyName: ids[0].companyName,
        nickName: ids[0].contacter,
        contactTel: ids[0].contacterTel,
        transportUserId: this.data.userId,
        goodsCreateUser: this.data.createUser,
        companyId: this.data.companyId
      }
      this.invitationManager.clickable = false
      saveList(params)
        .then(data => {
          this.$message({
            type: 'success',
            message: '邀请成功!'
          })
          this.close()
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.invitationManager.loading = false
        })
    },
    invitationFormSummit() {
      const params = this.exchangeData(this.invitationForm)
      this.loadData(params)
    },
    // 邀请全选没有被邀请的货源
    invitationSelection() {
      this.invitationData.forEach(i => {
        if (
          !i.inviteType &&
          !i.offerType &&
          i.selection !== this.allSelection
        ) {
          i.selection = !i.selection
        }
      })
    },
    // 邀请子项选择
    invitationChange() {
      this.allSelection = this.invitationData.every(i => i.selection)
    },
    loadInvitationData() {
      // 模拟请求
      this.invitationData = [
        {
          id: '001',
          place: '东营市广饶县——济南市高新区',
          msg: '成品油——#95汽油',
          date: '2019/03/18'
        },
        {
          id: '002',
          place: '东营市广饶县——济南市高新区',
          msg: '成品油——#95汽油',
          date: '2019/03/18'
        }
      ]
    },
    //  加载数据
    loadData() {
      this.invitationManager.loading = true
      const params = this.exchangeData(this.invitationForm)
      getInvitationGoodsList(
        this.invitationPagination,
        Object.assign({ transportUserId: this.data.userId }, params)
      )
        .then(data => {
          console.log(data,'666666666666666666666')
          this.invitationData = data.result.rows
          this.invitationPagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
          this.loadInvitationData()
        })
        .finally(() => {
          this.invitationManager.loading = false
        })
    },
    invitationChangeSize(size) {
      this.invitationPagination.pageSize = size
      this.loadData()
    },
    invitationChangeCurrent(current) {
      this.invitationPagination.pageNo = current
      this.loadData()
    },
    resetInvitationForm() {
      this.cleanModal(this.invitationForm)
      this.invitationFormSummit()
    }
  }
}
</script>
<style lang="scss" scoped>
$main-color: #be2316;
/deep/ [class^="el-icon-"] {
  margin-right: 7px;
}
.invitation-data {
  .invitation-form {
    margin-top: 0.5rem;
    .condition-group {
      padding-left: 8px;
      box-sizing: border-box;
      display: inline-block;
    }
    .manager-button {
      width: calc(100% - 540px);
      display: inline-block;
      .form-item-sou {
        width: 100%;
        text-align: left;
        /deep/ .el-form-item__content {
          width: 100%;
          button {
            &:last-child {
              float: right;
              margin-right: 8px;
              margin-top: 3.33px;
            }
          }
        }
      }
    }
  }
  .invitation-data-header {
    color: $main-color;
    font-weight: bold;
    background-color: #ffffff;
    height: 56px;
    margin-bottom: 1rem;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #ebeef5;
    position: relative;
    ul {
      display: flex;
      flex-wrap: nowrap;
      height: 100%;
      width: calc(100% - 16px);
      padding: 0px 8px;
      line-height: 56px;
      box-sizing: content-box;
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        min-width: 50px;
        height: 100%;
        line-height: 56px;
        text-align: center;
        &:nth-child(1) {
          flex-basis: 5%;
        }
        &:nth-child(2) {
          flex-basis: 25%;
        }
        &:nth-child(3) {
          flex-basis: 25%;
        }
        &:nth-child(4) {
          flex-basis: 25%;
        }
        &:nth-child(5) {
          flex-basis: 10%;
        }
        &:last-child {
          flex-basis: 20%;
        }
      }
    }
  }
  .invitation-data-body {
    position: relative;
    // min-height: 910px;
    background-color: #f5f5f5;
    .no-data-info {
      background-color: #fff;
      width: 100%;
      text-align: center;
      margin-top: 8px;
      height: 48px;
      line-height: 48px;
      font-size: 15px;
    }
    .data-item {
      margin: 8px 0px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #ebeef5;
      position: relative;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 56px;
        width: calc(100% - 16px);
        padding: 8px 8px;
        position: relative;
        background-color: white;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 64px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 25%;
          }
          &:nth-child(3) {
            flex-basis: 25%;
          }
          &:nth-child(4) {
            flex-basis: 25%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:last-child {
            flex-basis: 20%;
          }
        }
      }
      /deep/ .goods-item-details {
        border: 1px solid #ebeef5;
        z-index: 0;
      }
    }
  }
  .invitation-data-pagination {
    margin-top: 24px;
    padding: 16px 0px;
    background-color: white;
  }
}
</style>

